import Http from '../../http';
import {
  IMPORT_SUBSCRIPTIONS_START,
  IMPORT_SUBSCRIPTIONS_SUCCESS,
  IMPORT_SUBSCRIPTIONS_ERROR,
} from './constants';

// redux-less action
export const updateSubscriptionStatus = (ownerType, ownerId, subscriptionId, action) => {
  const url = `/${ownerType}/${ownerId}/memberships/subscriptions/${subscriptionId}`;
  return Http.put(url, { action });
};

const importSubscriptionsStart = () => ({
  type: IMPORT_SUBSCRIPTIONS_START,
});

const importSubscriptionsSuccess = payload => ({
  type: IMPORT_SUBSCRIPTIONS_SUCCESS,
  payload,
});

const importSubscriptionsError = () => ({
  type: IMPORT_SUBSCRIPTIONS_ERROR,
});

const importSubscriptions = dispatch => (ownerId, ownerType, file, data) => {
  dispatch(importSubscriptionsStart());

  const url = `/${ownerType}/${ownerId}/memberships/subscriptions/import`;
  return Http.postRaw(url, { ...data, file })
    .then((res) => {
      dispatch(importSubscriptionsSuccess(res));
      return res;
    }).catch((e) => {
      dispatch(importSubscriptionsError());
      throw e;
    });
};

export const importBrandSubscriptions = (brandId, file, data) => (dispatch) => {
  const creatorFn = importSubscriptions(dispatch);
  return creatorFn(brandId, 'brand', file, data);
};

export const importShopSubscriptions = (shopId, file, data) => (dispatch) => {
  const creatorFn = importSubscriptions(dispatch);
  return creatorFn(shopId, 'shop', file, data);
};
